var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { attrs: { "grid-list-xl": "", "text-xs-center": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm5: "", md3: "" } },
                [
                  _c("v-switch", {
                    attrs: { label: _vm.labelSwitch },
                    on: { change: _vm.onChangeSwitch },
                    model: {
                      value: _vm.switch1,
                      callback: function($$v) {
                        _vm.switch1 = $$v
                      },
                      expression: "switch1"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm5: "",
                    md3: "",
                    "offset-xs0": "",
                    "offset-lg6": ""
                  }
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "search",
                      label: "Buscar...",
                      "single-line": "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.dataTable,
          pagination: _vm.pagination,
          "item-key": "cod_vehiculo",
          "no-data-text": "Sin registros",
          "rows-per-page-items": _vm.rowsPerPageItems,
          search: _vm.search
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "headers",
            fn: function(props) {
              return [
                _c(
                  "tr",
                  _vm._l(props.headers, function(header) {
                    return _c(
                      "th",
                      {
                        key: header.text,
                        class: [
                          "column sortable",
                          _vm.pagination.descending ? "desc" : "asc",
                          header.value === _vm.pagination.sortBy ? "active" : ""
                        ],
                        on: {
                          click: function($event) {
                            return _vm.changeSort(header.value)
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v("arrow_upward")
                        ]),
                        _vm._v(
                          "\n          " + _vm._s(header.text) + "\n        "
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ]
            }
          },
          {
            key: "items",
            fn: function(props) {
              return [
                _c(
                  "tr",
                  {
                    attrs: { active: props.selected },
                    on: {
                      click: function($event) {
                        props.selected = !props.selected
                      }
                    }
                  },
                  [
                    _c("td", { staticClass: "text-xs-center" }, [
                      _vm._v(_vm._s(props.item.cod_vehiculo))
                    ]),
                    _c("td", { staticClass: "text-xs-center" }, [
                      _vm._v(_vm._s(props.item.nom_flota))
                    ]),
                    _c("td", { staticClass: "text-xs-center" }, [
                      _vm._v(_vm._s(props.item.patente_vehiculo))
                    ]),
                    _vm.switch1
                      ? _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.item.avl_chile) +
                              "\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm.switch1
                      ? _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.item.wisetrack_insertarposicion) +
                              "\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm.switch1
                      ? _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.item.cmp_btrack) +
                              "\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm.switch1
                      ? _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.item.log_solutions) +
                              "\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm.switch1
                      ? _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.item.int_samtech_cim) +
                              "\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm.switch1
                      ? _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.item.beetrack) +
                              "\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm.switch1
                      ? _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(props.item.owl))
                        ])
                      : _vm._e(),
                    _vm.switch1
                      ? _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.item.heligrafics) +
                              "\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm.switch1
                      ? _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.item.qanalytics) +
                              "\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm.switch1
                      ? _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.item.samtech_dch) +
                              "\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm.switch1
                      ? _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.item.int_codelco) +
                              "\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm.switch1
                      ? _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.item.int_camion_go) +
                              "\n        "
                          )
                        ])
                      : _vm._e(),
                    _c(
                      "td",
                      { staticClass: "text-xs-center actions" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              flat: "",
                              color: "primary",
                              title: "Modificar vehículo"
                            },
                            on: {
                              click: function($event) {
                                return _vm.showDialog(props.item)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("directions_car")])],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              flat: "",
                              color: "primary",
                              title: "Modificar Flota completa"
                            },
                            on: {
                              click: function($event) {
                                return _vm.showDialogFlota(props.item)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("groups")])],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "no-data",
            fn: function() {
              return [
                _c("div", { staticClass: "center" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.noDataMessage) + "\n        "
                  )
                ])
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.selected,
          callback: function($$v) {
            _vm.selected = $$v
          },
          expression: "selected"
        }
      }),
      _c("activar-integracion-dialog", {
        attrs: { dialog: _vm.dialog, item: _vm.items },
        on: {
          change: function($event) {
            return _vm.onDialogChange($event)
          },
          close: function($event) {
            return _vm.dialogClose($event)
          }
        }
      }),
      _c("activar-integracion-dialog-flota", {
        attrs: { dialog: _vm.dialogFlota, item: _vm.items },
        on: {
          change: function($event) {
            return _vm.onDialogFlotaChange($event)
          },
          close: function($event) {
            return _vm.dialogFlotaClose($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }